// TODO: usage-check

export class Patient {
    resourcetype: string;
    id: string;
    meta: {
        versionid: string,
        lastupdated: Date
    };
    gender: string;
    birthdate: Date;
    // defaultModel: string;
    // markedTriangles: [
    //     {
    //         id: number,
    //         color: string
    //     }
    // ];
    // photo: {
    //     src: string,
    //     opacity: number,
    //     zoom: number,
    //     brightness: number,
    //     contrast: number
    // };

    constructor(obj: Patient) {
        this.id = obj.id;
        this.resourcetype = obj.resourcetype;
        this.meta = obj.meta;
        this.gender = obj.gender;
        this.birthdate = obj.birthdate;

        // this.name = obj.name;
        // this.dob = obj.dob;
        // this.weight = obj.weight;
        // this.defaultModel = obj.defaultModel;
        // this.markedTriangles = obj.markedTriangles;
        // this.photo = obj.photo;
    }
}
